const nl = {
    'culture': 'nl-NL',
    'actions': {
        'add': 'Toevoegen',
        'addsupervisor': 'Begeleider toevoegen',
        'approverecords': 'Goedkeuren',
        'close': 'Sluiten',
        'delete': 'Verwijderen',
        'edit': 'Bewerken',
        'impersonate': 'Inzien',
        'login': 'Inloggen',
        'logout': 'Uitloggen',
        'next': 'Volgende',
        'newactivity': 'Nieuwe activiteit',
        'previous': 'Vorige',
        'ok': 'Ok',
        'save': 'Opslaan',
        'search': 'Zoeken',
        'register': 'Aanmelden',
        'unregister': 'Afmelden',
        'submit': 'Versturen',
        'view': 'Bekijken',
        'cancel': 'Annuleren',
        'select': 'Selecteren',
        'schduleitanyway': 'Toch inplannen'
    },
    'confirm': {
        'leaveWithoutSave': '<strong>Weet u het zeker?</strong><br />Er zijn niet opgeslagen wijzigingen',
        'delete': '<strong>Weet u het zeker?</strong><br />Record verwijderen',
        'waitinglist': 'Momenteel is deze activiteit vol.<br> Wil je op de wachtlijst komen?',
        'approve': 'wil je de tijd goedkeuren?',
        'closetime': 'Weet u zeker dat u de tijd wilt indienen?',
        'reopentime': 'Weet u zeker dat u de tijd opnieuw wilt openen?',
        'generateinvoice': 'Wilt u een factuur van de huidige maand genereren?',
        'resettotp': 'Weet u zeker dat u 2FA wilt resetten?',
        'override': 'Wilt u de wijzigingen in alle bestaande toekomstige gebeurtenissen overschrijven?'
    },
    'error': {
        'saveChanges': 'Er is een probleem opgetreden tijdens het opslaan van de gegevens',
        'deleteRecordConflict': 'Dit record kan niet worden verwijderd',
        'emailexists': 'Dit e-mailadres is al in gebruik',
        'emailnotfound': 'E-mail niet gevonden',
        'twofactorcode': 'Verificatiecode is vereist!',
        'invalid_code': 'Geef een geldige 2FA-code in!',
        'requiredtotp': 'Voer de 2FA-code in',
        'resettotp': 'Er is iets misgegaan bij het resetten van 2FA!',
        'resetpassword': 'Ongeldig oud wachtwoord!',
        'passwordmismatch': 'Het nieuwe wachtwoord en het bevestigde wachtwoord moeten hetzelfde zijn!',

    },
    'format': {
        'date': 'DD-MM-YYYY',
        'dateTime': 'DD-MM-YYYY HH:mm',
        'time': 'HH:mm',
        'timezone': 'UTC'
    },
    'path': {
        'home': '/',
        'login': '/login',
        'forgotpassword': '/wachtwoordvergeten',

    },
    'periods': {
        'short': {
            'sunday': 'Zo',
            'monday': 'Ma',
            'tuesday': 'Di',
            'wednesday': 'Wo',
            'thursday': 'Do',
            'friday': 'Vr',
            'saturday': 'Za',
            'january': 'Jan',
            'february': 'Feb',
            'march': 'Maa',
            'april': 'Apr',
            'may': 'Mei',
            'june': 'Jun',
            'july': 'Jul',
            'august': 'Aug',
            'september': 'Sep',
            'october': 'Okt',
            'november': 'Nov',
            'december': 'Dec',
        },
        'long': {
            'january': 'Januari',
            'february': 'Februari',
            'march': 'Maart',
            'april': 'April',
            'may': 'Mei',
            'june': 'Juni',
            'july': 'Juli',
            'august': 'Augustus',
            'september': 'September',
            'october': 'Oktober',
            'november': 'November',
            'december': 'December',
            'sunday': 'Zondag',
            'monday': 'Maandag',
            'tuesday': 'Dinsdag',
            'wednesday': 'Woensdag',
            'thursday': 'Donderdag',
            'friday': 'Vrijdag',
            'saturday': 'Zaterdag',
        },
        'week': 'Week',
        'month': 'Maand',
        'year': 'Jaar',
        'january': 'Januari',
        'february': 'Februari',
        'march': 'Maart',
        'april': 'April',
        'may': 'Mei',
        'june': 'Juni',
        'july': 'Juli',
        'august': 'Augustus',
        'september': 'September',
        'october': 'Oktober',
        'november': 'November',
        'december': 'December',
    },
    'status': {
        'status': 'Status',
        'loading': 'Laden...',
        'norecords': 'Geen gegevens gevonden',
        'loginfailed': 'Gebruikersnaam en/of wachtwoord onbekend',
        'invalidpassword': 'Het wachtwoord is ongeldig',
        'tokenexpired': 'Uw token voor het opnieuw instellen van uw wachtwoord is verlopen',
        'pending': 'In afwachting',
        'approved': 'Goedgekeurd'
    },
    'success': {
        'saveChanges': 'De gegevens zijn succesvol opgeslagen',
        'deleteRecord': 'De gegevens zijn succesvol verwijderd',
        'updatepassword': 'Uw wachtwoord is ingesteld. U kunt nu inloggen',
        'updatestatus': 'Activiteitsstatus is bijgewerkt',

    },
    'title': {
        'newactivity': 'Nieuwe activiteit aanmaken',
        'portal': 'Bont lite',
        'schdulealert': 'Inplannen met waarschuwing',
        'sidebar': 'Sleep iemand naar een dienst. Dubbele inzet, rusttijd en ontbrekende beschikbaarheid geven een waarschuwing, maar zijn te overrulen.',
        'monthlyoverview': 'Maandrooster begeleider',
        'monthlyoverviewdesc': 'Maandrooster begeleider',
        'controls': 'Roostercontroles'
    },
    'warnings': {
        'insufficientAttendants': 'Niet genoeg begeleiders',
        'unapprovedAttendants': 'Goed te keuren begeleiders',
        'unapprovedClientsFromWaitingList': 'Jongere van wachtlijst goed te keuren',
        'overLapAttendant': 'Begeleider dubbel ingeroosterd',
        'missingAttendantInfo': 'Ontbrekende begeleidersinfo',
        'insufficientRegistration': 'Onvoldoende aanmeldingen',
        'missingClientInfo': 'Ontbrekende jongereninfo',
        'timealert': 'Let op, je schrijf nachturen. Als je gelogeerd hebt dien je dit in drie verschillende shifts aan te bieden (avond, nacht/slapen en ochtend). Bij de nact/slaapuren zet je het vinkje \'nachturen\' aan.',
        'notaccessable': 'Pagina is niet toegankelijk',
        'individualreport': 'Deze individuele rapportage is geschreven door een medewerker van Bont indien u vragen heeft over deze rapportage, willen wij aan u vragen om contact op te nemen met uw contactpersoon.'

    },
    'active': 'Actief',
    'activities':'Activiteiten',
    'activityname': 'Naam activiteit',
    'all': 'Iedereen',
    'available': 'Beschikbaar',
    'availablesupervisor': 'Beschikbaar gesteld',
    'available': 'Beschikbaar',
    'aspercontract': 'Volgens contract',
    'checkavailibility': 'Beschikbaarheid bekijken',
    'checks': 'Checks',
    'client': 'Jongeren',
    'contract': 'Contract',
    'contracthourmonth': 'Contracturen maand',
    'controls': 'Controles',
    'createandaddtoschedule': 'Aanmaken en in rooster zetten',
    'dailyplanner': 'Dagplanner',
    'deployementneed':'Inzetmomenten nodig',
    'difference': 'Verschil',
    'doubleattendant': 'Dubbele inzet',
    'dualsupervisor': 'Dubbele begeleider',
    'employee': 'Dienst',
    'enddate': 'Eind Datum',
    'endtime': 'Eindtijd',
    'location': 'Locatie',
    'newactivity': 'Nieuwe activiteit aanmaken',
    'nightactivity':'Logeren met avond-, nacht- en ochtenddienst',
    'numberofsupervisorsrequired': 'Aantal begeleiders nodig',
    'managequalification': 'Kwalificaties beheren',
    'month': 'Maand',
    'monthlyplanner': 'Maandrooster begeleider',
    'open': 'Open',
    'openspace':'Open plekken',
    'reasonfordoubleplacement': 'Reden om ondanks dubbele plaatsing aan te maken',
    'requiredqualifications': 'Vereiste kwalificaties',
    'registeredclient': 'Aanwezige jongeren',
    'reported': 'Aangemeld',
    'standardactvity':'Gewone activiteit',
    'scheduled': 'Ingepland',
    'scheduledhour': 'ingeplande uren',
    'selectingyoungpeople': 'Jongeren selecteren',
    'supervisor': 'Begeleider',
    'supervisorneed': 'Begeleiders nodig',
    'startdate': 'Start  Datum',
    'starttime': 'Starttijd',
    'supervisors': 'Begeleiders',
    'template':'Template',
    'verify': 'Verifieer 2FA-code',
    'verifiedby': 'Geverifieerd door',
    'verifieddate': 'Geverifieerde datum',
    'warning': 'Waarschuwing',
    'website': 'Website',
    'week': 'Week',
    'year': 'Jaar',
    'yes': 'Ja',
    'youngpeoplequalifyforservices': 'Jongeren gelden voor alle diensten',
    'youngpersonspot':'Jongerenplaatsen'
};

export default nl;